/**
 * Service for creating SD Audience campaigns
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const SdAudienceCampaignAPI = {
    /**
     * Sube archivos CSV y logo
     */
    uploadFiles: async function (ownProductsCSV, audiencesCSV, logo) {
        const formData = new FormData();

        if (ownProductsCSV) formData.append('ownProductsCSV', ownProductsCSV);
        if (audiencesCSV) formData.append('audiencesCSV', audiencesCSV);
        if (logo) formData.append('logo', logo);

        const response = await fetch(`${API_BASE_URL}/sd-audience-campaigns/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Error uploading files');
        }

        return await response.json();
    },

    /**
     * Obtiene presets de audiencias sugeridas
     */
    getPresets: async function () {
        const response = await fetch(`${API_BASE_URL}/sd-audience-campaigns/presets`);
        if (!response.ok) {
            return { success: false, data: [] };
        }
        return await response.json();
    },

    /**
     * Crea la campaña SD Audience completa
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('headline', options.headline || '');
        formData.append('ownProducts', JSON.stringify(options.ownProducts || []));
        formData.append('audiences', JSON.stringify(options.audiences || []));

        if (options.startDate) formData.append('startDate', options.startDate);
        if (options.endDate) formData.append('endDate', options.endDate);
        if (options.bidOptimization) formData.append('bidOptimization', options.bidOptimization);
        if (options.defaultBid) formData.append('defaultBid', options.defaultBid);
        if (options.state) formData.append('state', options.state);
        if (options.logo) formData.append('logo', options.logo);

        const response = await fetch(`${API_BASE_URL}/sd-audience-campaigns/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Error creating audience campaign');
        }

        return await response.json();
    }
};

export default SdAudienceCampaignAPI;
